import React, { Fragment, useRef } from 'react';
import NavigationMenuItem from './NavigationMenuItem';
import NavigationMenuLink from './NavigationMenuLink';
import { translate } from '../Services/translation';

const NavigationMenu = ({ links = [] }) => {
    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
    };

    return (
        <Fragment>
            <button
                className="navbar__link--block navbar__icon--menu navbar__icon"
                onClick={toggleMenu}
                title={translate('general.menu') || 'menu'}
            ></button>
            {links.length > 0 && (
                <ul
                    className="navbar__menu"
                    ref={menuRef}
                >
                    <li>
                        <div className="navbar__menu-header">
                            <button
                                className="navbar__icon navbar__icon--close"
                                onClick={toggleMenu}
                                title={translate('close') || 'close'}
                            ></button>
                        </div>
                    </li>
                    {links.map((link) =>
                        (link.links || []).length > 0 ? (
                            <NavigationMenuItem
                                links={link.links}
                                contentLink={link}
                                key={link.url}
                            />
                        ) : (
                            link.name &&
                            <NavigationMenuLink
                                contentLink={link}
                                key={link.url}
                            />
                        )
                    )}
                </ul>
            )}
        </Fragment>
    );
};

export default NavigationMenu;
